// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__Of6v9","padder":"styles_padder___FLbJ","rounded":"styles_rounded__3MZ5W","appMainContent":"styles_appMainContent__1GT3Y"};